import React, { useState, useEffect } from "react";
import { styled } from "@mui/system";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../App";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function SubscriptionPage() {
  const { t, i18n } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const [AcceptTerms, setAcceptTerms] = useState(0);

  const [Loading, setLoading] = useState(false);

  const AcceptTermsFunc = (event) => {
    setAcceptTerms(event.target.checked ? 1 : 0);
  };

  const CheckEmail = () => {
    const data = {
      Email: user?.Email,
    };

    axios
      .post(`${MyDomain}EmailsSubs/FindMatchingEmailSub`, data) // API URL for adding products to the cart
      .then((response) => {
        console.log(response.data);
        if (response.data) {
          setAcceptTerms(1);
        } else {
          setAcceptTerms(0);
        }
        setLoading(true);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  useEffect(() => {
    CheckEmail();
  }, []);

  if (!Loading) return <>loading</>;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 50,
      }}
    >
      <Checkbox
        style={{
          paddingTop: 3,
        }}
        {...label}
        icon={
          <Box
            sx={{
              width: 18,
              height: 18,
              border: "1.4px solid black", // border for unchecked state
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 1,
            }}
          />
        } // Unchecked icon
        checkedIcon={
          <Box
            sx={{
              width: 18,
              height: 18,
              border: "1.4px solid black", // border for checked state
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 1,
            }}
          >
            <Box
              sx={{
                width: 10, // smaller square inside
                height: 10,
                backgroundColor: "black", // color of the small square
              }}
            />
          </Box>
        } // Checked icon with small square
        checked={AcceptTerms === 1}
        onChange={AcceptTermsFunc}
        sx={{
          padding: 0, // remove padding
        }}
      />
      <a>Unsubscribe to email notifications!</a>
    </div>
  );
}
